// Static route table for the area; pages load lazily (one chunk + its CSS).
import type { RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/moduleversions/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

export const moduleVersionsRoutes: RouteObject[] = [
  {
    path: 'moduleversions',
    handle: crumb('Module versions'),
    children: [
      { index: true, lazy: page('ModuleVersionListPage') },
      { path: 'create', handle: crumb('Create'), lazy: page('ModuleVersionCreatePage') },
      {
        path: ':id',
        handle: { crumb: (match) => match.params.id ?? null } satisfies CrumbHandle,
        children: [
          { index: true, lazy: page('ModuleVersionEditPage') },
          { path: 'show', handle: crumb('Show'), lazy: page('ModuleVersionShowPage') }
        ]
      }
    ]
  }
]
